import React from "react";

interface InputFormMandatoryProps {
    className?: string
};

class InputFormMandatory extends React.Component<InputFormMandatoryProps> {

    render(): React.ReactNode {

        return (
        <div>
            <div
                className="mandatory-field"
                style={{ float: "left" }} />
            <div className="required-field">
                Required Fields *
            </div>
        </div>
        );

    }

}

export default InputFormMandatory;